import styled from 'styled-components';
import Loader from 'react-loader-spinner';
import { colors } from '../../globalStyles';

export { Button, ButtonSmall, ButtonExtraSmall, ButtonExtraMargin, ButtonGray } from './Button';
export { Title, MainTitle, TitleAlignLeft } from './Title';
export { Details, Column } from './Details';
export { Center, FlexCol, FlexWrappedRow, FlexRow, FlexStart, SpaceBetween } from './Flex';
export { Link, LinkGray, LinkBack, LinkRight, LinkBackHeader } from './Link';
export { Box, BoxName, BoxTitle, BoxDivider, BoxTitleSmall, BoxWarning } from './Box';

export const inputStyle = {
  style: {
    base: {
      fontSize: '16px',
      '::placeholder': {
        color: colors.input,
      },
    },
  },
};

export const Container = styled.div({
  display: 'block',
  margin: 'auto',
  '@media only screen and (min-width: 1281px) and (min-height: 800px)': {
    position: 'relative',
    top: '50%',
    transform: 'translateY(calc(-50% - 50px))',
  },
});

export const HeaderLogoDiv = styled.div({
  backgroundColor: colors.darkGreen,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '11vh',
  height: '50px',
  cursor: 'pointer',
  '&:focus': {
    outline: 'none',
  },
  padding: '0px 10px',
  '&:hover': {
    opacity: 0.7,
  },
});

export const HeaderMenuButton = styled.a({ marginRight: '15px' });

export const HeaderLogoImg = styled.img({
  height: '28px',
});

export const Spacer = styled.div({
  height: '25px',
  '@media only screen and (max-width: 944px)': {
    height: '5px',
  },
});

export const Divider = styled.hr({
  height: '1px',
  width: '100%',
  backgroundColor: colors.border,
});

export const EmptyLine = styled.p({
  height: '2px',
  marginBottom: '30px',
});

export const Loading = styled(Loader as any)({
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center',
});

export const Small = styled.small((props: { red?: boolean; }) => ({
  fontSize: '17px',
  fontWeight: 100,
  color: props.red ? colors.red : colors.gray,
}));

export const DateCvcBox = styled.div({ width: '47%' });

export const InfoMessage = styled.p({ fontSize: '16px !important' });

export const ToggleBox = styled.label({
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px',
  marginBottom: '10px',
});

export const ToggleSmall = styled(Small as any)({
  marginRight: '10px',
});

export const Bold = styled.b({ marginLeft: '5px' });
